<template>
    <div>
        <InventoryMainSku
        v-if="!mainSku && !micromanage"
        :skuCreate="skuCreate"
        @done="eventCatcher"/>

        <div class="container">
            <div v-if="micromanage" class="columns is-multiline">
                <!--Listado de skus de varaintes.-->
                <div  
                    v-for="(x,i) in skus"
                    v-if="x.variant != null"
                    :key="x.pk" 
                    :index="i"
                    class="column is-one-third"
                >
                    <div class="card">
                        <div class="card-content">
                            <a 
                            class="has-text-danger"
                            @click="deleteSku(x)">
                                <b-icon icon="trash" size="is-small"></b-icon>
                                Delete
                            </a>
                            <b-field>
                                <b-input
                                v-model="x.code"
                                @input=updateSku(x)>
                                </b-input>
                            </b-field>
                            <p class="title is-size-4">
                                <span v-for="v in x.variantValues"
                                :key="v">
                                    {{v}}, 
                                </span>
                            </p>
                            <p class="subtitle">
                                {{x.quantity}} units.
                            </p>
                        </div>
                    </div>
                </div>
                <!-- Fin Listado de skus de varaintes.-->
            </div>
            <InventoryAddSku
            v-if="micromanage"
            :variants="variants"
            :skuCreate="skuCreate"
            @done="eventCatcher"
            />
            
            <!--Total en skus-->
            <div class="columns">
                <div class="column is-full ">
                    <p class="title" style="margin:0">
                        Total en stock <span  v-if="!micromanage">{{mainSku.getProductCode}}</span>:
                    </p>
                    <span class="title total-stock has-text-success">
                        {{totalStock}}
                    </span>
                </div>
                
            </div>
            <!--Fin total en skus-->


            <!-- Tabla listando movimientos -->
            <div class="columns">
                <div class="column is-full">
                    <b-table
                    :data="count > 0 ? moves : []"
                    :loading="loading"
                    >
                        <template slot-scope="props">
                            <b-table-column field="id" label="ID" width="40" numeric>
                                
                                {{ props.row.id }}
                            </b-table-column>
                            <b-table-column field="code" label="Code">
                                <a 
                                v-if="props.row.isEditable"  
                                class="has-text-danger"
                                @click="deleteMovement(props.row.id)">
                                    <b-icon icon="trash" size="is-small"></b-icon>
                                </a>
                                {{ props.row.skuCode }}
                                
                            </b-table-column>
                            <b-table-column field="code" label="Title">
                                {{ props.row.title }}
                                
                            </b-table-column>

                            <b-table-column field="concept" label="Concepto">
                                {{props.row.concept}}
                            </b-table-column>

                            <b-table-column field="code" label="Quantity" numeric>
                                <span
                                v-if="props.row.isNegative"
                                class="has-text-danger"
                                >
                                -{{ props.row.quantity }}
                                </span>
                                <span
                                v-else
                                class="has-text-success"
                                >
                                {{ props.row.quantity }}
                                </span>
                            </b-table-column>
                        </template>
                        <template slot="empty">
                            <section class="section">
                                <div class="content has-text-grey has-text-centered">
                                    <p>
                                        <b-icon
                                            icon="emoticon-sad"
                                            size="is-large">
                                        </b-icon>
                                    </p>
                                    <p>Nothing here.</p>
                                </div>
                            </section>
                        </template>
                    </b-table>

                    <div class="p-top-30">
                        <b-pagination
                            :total="count"
                            :per-page="perPage"
                            :current.sync="page"
                            :range-before="2"
                            :rounded="true"
                            :range-after="2"
                            order="is-centered"
                            @change="onPageChange"
                            icon-prev="chevron-left"
                            icon-next="chevron-right"
                        >
                        </b-pagination>
                    </div>

                </div>
            </div>
            <!-- Fin tabla listando movimientos -->

            <!-- Boton y modal agregar movimientos -->
            <div class="columns is-centered">
                <div class="column is-full has-text-centered">
                    <b-button
                    type="is-primary"
                    rounded
                    @click="addModalStatus=true">
                        <b-icon
                        icon="plus"
                        size="is-small">
                        </b-icon>
                        Add an adjustment movement
                    </b-button>
                </div>
            </div>
            <b-modal :active.sync="addModalStatus"  scroll="keep">
            <div class="modal-card has-text-centered" style="width: auto">

                <div class="modal-card-body">
                    <div class="columns">
                        <div v-if="micromanage" class="column is-one-third has-text-left">
                            <b-field
                            label="SKU">
                                <b-select
                               
                                v-model="newMovement.sku"
                                expanded
                                >
                                    <option v-for="opt in skus" v-if="opt.variant" :key="opt.id" :value="opt.id">{{opt.title}}</option>
                                </b-select>
                            </b-field>
                        </div>
                        <div class="column is-one-third has-text-left">
                            <b-field
                            label="Quantity"
                            >
                                <b-numberinput
                                min="0"
                                controls-rounded
                                type="is-light"
                                required
                                v-model="newMovement.quantity">                                
                                </b-numberinput>
                            </b-field>
                        </div>
                        <div class="column is-one-third ">
                            <b-field 
                            label="Is an exit">
                                <b-switch
                                rounded
                                v-model="newMovement.isNegative">
                                </b-switch>
                            </b-field>
                        </div>
                    </div>
                    <div class="columns">
                        <div class="column is-full has-text-left">
                            <b-field
                            label="Concept">
                                <b-input
                                max="70"
                                v-model="newMovement.concept">
                                </b-input>
                            </b-field>
                        </div>
                    </div>
                </div>
                <div class="columns is-centered ">
                    <div class="column is-full has-text-centered">
                        <b-button
                        type="is-light"
                        rounded
                        class="m-r-5"
                        @click="addModalStatus=false">
                            Cancel
                        </b-button>
                        <b-button
                        type="is-primary"
                        rounded
                        @click="createMovement"
                        :loading="addLoading">
                            <b-icon
                            icon="save"
                            size="is-small">
                            </b-icon>
                            Save movement
                        </b-button>
                    </div>
                </div>
            </div>
            </b-modal>
            <!-- Fin boton y modal movimientos -->
        </div>

    </div>
</template>

<script>
import {getHandler, postHandler, deleteHandler, patchHandler, debounce} from "./../../../../services/http.js";
import InventoryMainSku from "./InventoryMainSku.vue";
import InventoryAddSku from "./InventoryAddSku.vue"
export default {
    components:{
        InventoryMainSku,
        InventoryAddSku
    },
    props:{
        movementList:{
            type:String,
            default:""
        },
        skuList:{
            type:String,
            default:""
        },
        movementAdd:{
            type:String,
            default:""
        },
        movementDestroy:{
            type:String,
            default:""
        },
        skuCreate:{
            type:String,
            default:""
        },
        variants:{
            type:Array,
            default:new Array([])
        },
        micromanage:{
            type:Boolean,
            default:false
        },
        totalStock:{
            type:Number,
            default:0
        }
    },
    data(){
        return{
            loading:false,
            skuPK:0,
            skus:[],
            count:0,
            moves:[],
            perPage:24,
            page:1,
            addModalStatus:false,
            newMovement:{
                isNegative:false,
                isEditable:true,
                quantity:0,
                concept:''
            },
            addLoading:false,
        }
    },
    methods:{
        async fetchSKUs(){
            this.loading = true
            let response = await getHandler(this.skuList, {error:false, success:false})
            this.skus=response
            console.log(this.skus)
            this.loading = false
        },

        updateSku: debounce(
            async function(sku){
                let msg = {resource:"notify"}
                this.loading=true
                let res = await patchHandler(sku.getEditUrl, sku, {error:msg, success:msg})
                this.loading=false
                this.fetchSKUs()
            },
            500
        ),
        async deleteSku(sku){
            let msg = {resource:"notify"}
            this.loading=true
            let res = await deleteHandler(sku.getEditUrl, {error:msg, success:msg})
            this.loading=false
            this.$emit("getProd")
            this.fetchSKUs()
        },
        async fetchMovements(){
            this.loading = true
            let url = `${this.movementList}&page=${this.page}`
            if (this.micromanage){
                url = url + "&micromanage=TRUE"
            }
            let response = await getHandler(url, {error:false, success:false})
            this.count = response.count
            this.moves = response.results
            console.log(this.moves)
            this.loading=false
        },
        onPageChange(page){
            this.page = page
            this.fetchMovements()
        },
        eventCatcher(){
            this.fetchSKUs()
            this.$emit("getProd")
        },
        async createMovement(){
            this.addLoading = true
            let error={
                resource:"notify"
            }
            let success={
                resource:"notify"
            }
            if(!this.micromanage){
                this.newMovement.sku = this.mainSku.id
            }
            let repsonse = await postHandler(this.movementAdd, this.newMovement, {error, success})
            this.newMovement = {
                isNegative:false,
                isEditable:true,
                quantity:0,
                concept:''
            }
            this.addLoading = false
            this.addModalStatus = false
            this.$emit("getProd")
            this.fetchMovements()
            this.fetchSKUs()
        },
        async deleteMovement(id_){
            let error={
                resource:"notify"
            }
            let success={
                resource:"notify"
            }
            let url = this.movementDestroy.replace("0000", id_)
            let repsonse = await deleteHandler(url, {error, success})
            this.$emit("getProd")
            this.fetchMovements()
            this.fetchSKUs()
        }
    },
    computed:{
        mainSku(){
            return this.skus.find(element => !element.variant)
        }
    },
    watch:{
        micromanage: function(val){
            this.fetchMovements()
        }
    },
    created(){
        this.fetchSKUs()
        this.fetchMovements()
    }
}
</script>

<style lang="scss" scoped>
.total-stock{
    font-size: 4.5em;
    margin: 0;
}
</style>
